require('framework/polyfills').then(() => {
    require('framework/vendors');
    require('framework/odigeo');
    require('framework/odigeo.utils');
    require('framework/odigeo.utils.cookies');
    Odigeo.UIElements = {};
    window.executeOFSetupJs();
    $(() => require('../desktop.flights-checkout'));
});
